import { render, staticRenderFns } from "./HomeProductComponent.vue?vue&type=template&id=e722f870&scoped=true&"
import script from "./HomeProductComponent.vue?vue&type=script&lang=js&"
export * from "./HomeProductComponent.vue?vue&type=script&lang=js&"
import style0 from "./HomeProductComponent.vue?vue&type=style&index=0&id=e722f870&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e722f870",
  null
  
)

export default component.exports